import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

export default function LegalPage({ title, lastUpdated, children, testId }) {
    const { lang, t } = useT();
    const homeHref = lang === "hi" ? "/hi" : "/";
    return (
        <div
            data-testid={testId || "legal-page"}
            className="min-h-screen bg-background"
        >
            <header className="border-b border-border/60 sticky top-0 bg-background/90 backdrop-blur-md z-30">
                <div className="max-w-4xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
                    <Link
                        to={homeHref}
                        data-testid="legal-back"
                        className="inline-flex items-center gap-2 text-sm text-primary hover:text-accent transition-colors"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />{" "}
                        {lang === "hi" ? "होम पर वापस" : "Back to home"}
                    </Link>
                    <Link
                        to={homeHref}
                        aria-label="CHIGLE — home"
                        className="font-display text-2xl tracking-tight uppercase text-primary"
                    >
                        CHIGLE<span className="text-accent">.</span>
                    </Link>
                </div>
            </header>

            <main id="main" className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="text-xs uppercase tracking-[0.3em] text-accent font-semibold mb-6">
                    {lang === "hi" ? "क़ानूनी" : "Legal"}
                </div>
                <h1 className="font-display text-5xl md:text-7xl text-primary tracking-tight leading-[0.95] mb-4">
                    {title}
                </h1>
                <div className="text-sm text-muted-foreground mb-12">
                    {lang === "hi" ? "अंतिम अपडेट · " : "Last updated · "}
                    {lastUpdated}
                </div>
                <article className="prose-chigle space-y-6 text-foreground/85 leading-relaxed">
                    {children}
                </article>
            </main>
        </div>
    );
}
